import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const DeleteDocumentModal = ({ isOpen, onClose, onConfirm, document, getAssigneeName }) => {
  if (!isOpen || !document) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="modal-header">
          <h2>Confirm Delete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to delete this document?</p>
          <div className="document-details">
            <div className="detail-row">
              <span className="detail-label">Document Name:</span>
              <span className="detail-value">{document.documentTitle || "Untitled"}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Assignee:</span>
              <span className="detail-value">{getAssigneeName(document.assigneeId)}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Uploaded:</span>
              <span className="detail-value">
                {document.timestamp ? new Date(document.timestamp).toLocaleString() : 'Unknown'}
              </span>
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="delete-confirm-button" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDocumentModal;
